// Token helpers (reverted): keep minimal helpers without JWT flow
let accessTokenMem = null;
let refreshTokenMem = null;

const ACCESS_KEY = 'ce.accessToken';
const REFRESH_KEY = 'ce.refreshToken';

const getFromSession = (key) => {
  try { return sessionStorage.getItem(key); } catch { return null; }
};
const setInSession = (key, value) => {
  try { if (value) sessionStorage.setItem(key, value); else sessionStorage.removeItem(key); } catch {}
};

const getFromLocal = (key) => {
  try { return localStorage.getItem(key); } catch { return null; }
};
const setInLocal = (key, value) => {
  try { if (value) localStorage.setItem(key, value); else localStorage.removeItem(key); } catch {}
};

export const setTokens = ({ accessToken, refreshToken }, persist = true) => {
  if (accessToken) accessTokenMem = accessToken;
  if (refreshToken) refreshTokenMem = refreshToken;
  if (persist) {
    if (accessToken) { setInSession(ACCESS_KEY, accessToken); setInLocal(ACCESS_KEY, accessToken); }
    if (refreshToken) { setInSession(REFRESH_KEY, refreshToken); setInLocal(REFRESH_KEY, refreshToken); }
  }
};

export const getAccessToken = () => accessTokenMem || getFromSession(ACCESS_KEY) || getFromLocal(ACCESS_KEY);
export const getRefreshToken = () => refreshTokenMem || getFromSession(REFRESH_KEY) || getFromLocal(REFRESH_KEY);

export const clearTokens = () => {
  accessTokenMem = null;
  refreshTokenMem = null;
  setInSession(ACCESS_KEY, null);
  setInSession(REFRESH_KEY, null);
  setInLocal(ACCESS_KEY, null);
  setInLocal(REFRESH_KEY, null);
};

export const decodeJwt = (token) => {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
};
